import { useSelector } from 'react-redux'

import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined'

import RpcApiClient from 'datasources/RpcApiClient'

import '../filesMenu.css'

function DeleteModal(props) {
  const authData = useSelector((state) => state.auth.authData)

  const deleteProject = () => {
    props.deleteFeatures()
    const body = {
      isBlocked: false,
      files: props.projects.filter((val, i) => val.projectName === props.folderId),
    }
    body.files[0].s3 ? RpcApiClient.lockFiles(authData.jwtToken, body) : null
    const updateLabels = props.projects.filter((val, i) => val.projectName !== props.folderId)
    if (updateLabels.length > 0) {
      updateLabels.map((val, i) => (i === 0 ? (val.active = true) : (val.active = false)))
      props.setProjects(updateLabels)
      props.setProject(updateLabels[0].projectName)
    } else {
      props.setProjects([{ projectName: 'New Project', visible: true, active: true, height: true }])
      props.setProject('New Project')
    }

    props.setDeleteModal(false)
  }

  return (
    <div className="save-file-modal" style={{ display: 'grid', width: '450px' }}>
      <IconButton size="small" component="span" onClick={() => props.setDeleteModal(false)} className="sf-modal-close">
        <CloseIcon />
      </IconButton>
      <ErrorOutlineOutlinedIcon style={{ margin: 'auto', height: '65px', width: '65px', color: '#ffa430' }} />
      <h3 style={{ fontWeight: 'bold', margin: 'auto' }}>Are you sure you want to delete {props.folderId}?</h3>
      <div style={{ display: 'flex', flexFlow: 'column', gap: '15px' }}>
        <div style={{ display: 'flex', marginTop: '15px' }}>
          <button style={{ width: '140px', margin: 'auto' }} onClick={() => props.setDeleteModal(false)}>
            Cancel
          </button>
          <button className="df-delete-btn" onClick={() => deleteProject()}>
            Delete
          </button>
        </div>
      </div>
    </div>
  )
}

export default DeleteModal
